/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Contract, utils } from "ethers";
const _abi = [
    {
        type: "function",
        name: "getGlobalRevenueFee",
        inputs: [],
        outputs: [
            {
                name: "",
                type: "uint256",
                internalType: "uint256",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "getPositionData",
        inputs: [
            {
                name: "position",
                type: "address",
                internalType: "address",
            },
        ],
        outputs: [
            {
                name: "",
                type: "tuple",
                internalType: "struct IUniswapV3LeverageDataProvider.PositionData",
                components: [
                    {
                        name: "uniswapV3Position",
                        type: "tuple",
                        internalType: "struct IUniswapV3DataProvider.PositionData",
                        components: [
                            {
                                name: "tokenId",
                                type: "uint256",
                                internalType: "uint256",
                            },
                            {
                                name: "token0",
                                type: "address",
                                internalType: "address",
                            },
                            {
                                name: "token1",
                                type: "address",
                                internalType: "address",
                            },
                            {
                                name: "fee",
                                type: "uint24",
                                internalType: "uint24",
                            },
                            {
                                name: "tickLower",
                                type: "int24",
                                internalType: "int24",
                            },
                            {
                                name: "tickCurrent",
                                type: "int24",
                                internalType: "int24",
                            },
                            {
                                name: "tickUpper",
                                type: "int24",
                                internalType: "int24",
                            },
                            {
                                name: "sqrtPriceX96",
                                type: "uint160",
                                internalType: "uint160",
                            },
                            {
                                name: "amount0",
                                type: "uint256",
                                internalType: "uint256",
                            },
                            {
                                name: "amount1",
                                type: "uint256",
                                internalType: "uint256",
                            },
                            {
                                name: "fee0",
                                type: "uint256",
                                internalType: "uint256",
                            },
                            {
                                name: "fee1",
                                type: "uint256",
                                internalType: "uint256",
                            },
                            {
                                name: "liquidity",
                                type: "uint128",
                                internalType: "uint128",
                            },
                        ],
                    },
                    {
                        name: "debtAsset",
                        type: "address",
                        internalType: "address",
                    },
                    {
                        name: "debt",
                        type: "uint256",
                        internalType: "uint256",
                    },
                    {
                        name: "revenueFee0",
                        type: "uint256",
                        internalType: "uint256",
                    },
                    {
                        name: "revenueFee1",
                        type: "uint256",
                        internalType: "uint256",
                    },
                    {
                        name: "revenueFeePercent",
                        type: "uint256",
                        internalType: "uint256",
                    },
                ],
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "getPositionsData",
        inputs: [
            {
                name: "positions",
                type: "address[]",
                internalType: "address[]",
            },
        ],
        outputs: [
            {
                name: "datas",
                type: "tuple[]",
                internalType: "struct IUniswapV3LeverageDataProvider.PositionData[]",
                components: [
                    {
                        name: "uniswapV3Position",
                        type: "tuple",
                        internalType: "struct IUniswapV3DataProvider.PositionData",
                        components: [
                            {
                                name: "tokenId",
                                type: "uint256",
                                internalType: "uint256",
                            },
                            {
                                name: "token0",
                                type: "address",
                                internalType: "address",
                            },
                            {
                                name: "token1",
                                type: "address",
                                internalType: "address",
                            },
                            {
                                name: "fee",
                                type: "uint24",
                                internalType: "uint24",
                            },
                            {
                                name: "tickLower",
                                type: "int24",
                                internalType: "int24",
                            },
                            {
                                name: "tickCurrent",
                                type: "int24",
                                internalType: "int24",
                            },
                            {
                                name: "tickUpper",
                                type: "int24",
                                internalType: "int24",
                            },
                            {
                                name: "sqrtPriceX96",
                                type: "uint160",
                                internalType: "uint160",
                            },
                            {
                                name: "amount0",
                                type: "uint256",
                                internalType: "uint256",
                            },
                            {
                                name: "amount1",
                                type: "uint256",
                                internalType: "uint256",
                            },
                            {
                                name: "fee0",
                                type: "uint256",
                                internalType: "uint256",
                            },
                            {
                                name: "fee1",
                                type: "uint256",
                                internalType: "uint256",
                            },
                            {
                                name: "liquidity",
                                type: "uint128",
                                internalType: "uint128",
                            },
                        ],
                    },
                    {
                        name: "debtAsset",
                        type: "address",
                        internalType: "address",
                    },
                    {
                        name: "debt",
                        type: "uint256",
                        internalType: "uint256",
                    },
                    {
                        name: "revenueFee0",
                        type: "uint256",
                        internalType: "uint256",
                    },
                    {
                        name: "revenueFee1",
                        type: "uint256",
                        internalType: "uint256",
                    },
                    {
                        name: "revenueFeePercent",
                        type: "uint256",
                        internalType: "uint256",
                    },
                ],
            },
        ],
        stateMutability: "view",
    },
];
export class IUniswapV3LeverageDataProvider__factory {
    static createInterface() {
        return new utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi, signerOrProvider);
    }
}
IUniswapV3LeverageDataProvider__factory.abi = _abi;
//# sourceMappingURL=IUniswapV3LeverageDataProvider__factory.js.map